import shippingOptionsActionTypes from './actionTypes';
import cartActionTypes from '../cart/actionTypes';
import createReducer from '../utils/createReducer';
import type { ShippingOptionsState } from '../../types';

const initialState: ShippingOptionsState = {
  shippingOptions: undefined,
  selectedShippingMethodId: undefined,
  selectedShippingMethodIsUnverified: false,
  selectedShippingMethodIsDefaulted: false,
  selectedShippingMethodName: undefined,
  selectedShippingMethodEarliestArrivalDate: undefined,
  selectedShippingMethodLocalizedDisplayInfo: undefined,
  deliveryOptionMetadata: undefined,
  isOptionsOperationInFlight: false,
  caveats: undefined,
  optionSetError: undefined,
  retrievalStatus: undefined,
  isRefreshInFlight: false,
};

export default createReducer(initialState)({
  [cartActionTypes.CART_LOAD_SUCCESS]: (
    state: ShippingOptionsState,
    action: any
  ) => {
    const {
      shippingData: {
        shippingQuotesData,
        shippingMethodId,
        shippingMethodName,
        earliestArrivalDate,
        localizedDisplayInfo,
        deliveryOptionMetadata,
      },
    } = action.cart;
    const { shippingQuotes, status, ...rest } = shippingQuotesData || {};
    return {
      ...state,
      ...rest,
      isLoaded: true,
      isOptionsArrayOutdated: false,
      error: undefined,
      selectedShippingMethodId: shippingMethodId,
      selectedShippingMethodName: shippingMethodName,
      selectedShippingMethodEarliestArrivalDate: earliestArrivalDate,
      selectedShippingMethodLocalizedDisplayInfo: localizedDisplayInfo,
      deliveryOptionMetadata,
      shippingOptions: shippingQuotes,
      retrievalStatus: status,
    };
  },
  [shippingOptionsActionTypes.SHIPPING_OPTIONS_SET_FAIL]: (
    state: ShippingOptionsState,
    action: any
  ) => ({
    ...state,
    optionSetError: action.error,
  }),
  [shippingOptionsActionTypes.SHIPPING_OPTIONS_SET_SUCCESS]: (
    state: ShippingOptionsState
  ) => ({
    ...state,
    optionSetError: undefined,
  }),
  [shippingOptionsActionTypes.SHIPPING_OPTIONS_REFRESH_START]: (
    state: ShippingOptionsState
  ) => ({
    ...state,
    isRefreshInFlight: true,
  }),
  [shippingOptionsActionTypes.SHIPPING_OPTIONS_REFRESH_SUCCESS]: (
    state: ShippingOptionsState
  ) => ({
    ...state,
    isRefreshInFlight: false,
  }),
  [shippingOptionsActionTypes.SHIPPING_OPTIONS_REFRESH_FAIL]: (
    state: ShippingOptionsState
  ) => ({
    ...state,
    // for failure, just mark the state as no longer actively refreshing,
    // we should still be showing the error that there are no options
    isRefreshInFlight: false,
  }),
});
